import type { GroupBase, Props } from 'react-select';
import Select from 'react-select';
import styled, { css } from 'styled-components';

// Единственный правильный способ добавить кастомный тип в react-select
// https://github.com/JedWatson/react-select/discussions/5340#discussioncomment-3639080
// Делаем так для того, чтобы можно было передать кастомные свойства(cy в нашем случае).
declare module 'react-select/dist/declarations/src/Select' {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    export interface Props<Option, IsMulti extends boolean, Group extends GroupBase<Option>> {
        cy?: string;
        ref?: React.Ref<Select<Option, boolean, GroupBase<Option>>>;
    }
}

interface SelectorProps extends Props {
    isError: boolean;
    withoutBg: boolean;
    width: string;
    menuHeight: number;
}

const defaultControlCSS = css<SelectorProps>`
    background: ${props => props.theme.selector.base.background};
    padding: 0 5px 0 10px;
    transition: border 0.2s ease;
    ${props =>
        props.isError &&
        css`
            border-color: ${props => props.theme.root.input.error.borderColor};
            background: ${props => props.theme.root.colors.primary['10%']};
        `}

    &:hover {
        border-color: ${props => props.theme.root.input.root.borderColor};
    }

    &--menu-is-open,
    &--menu-is-open:hover {
        border-color: ${props => props.theme.root.input.focused.borderColor};

        .selector__indicators {
            svg {
                transform: rotate(180deg);
            }
        }
    }
`;

const withoutBgStyles = css<SelectorProps>`
    background: transparent;
`;

export const BorderCut = styled.div`
    overflow: hidden;
    border-radius: 16px;
`;

export const StyledSelect = styled(Select)<SelectorProps>`
    font-weight: normal;
    font-size: 15px;
    line-height: 24px;
    width: ${props => props.width};

    .selector__control {
        width: 100%;
        overflow: hidden;
        height: 52px;
        border: none;
        cursor: pointer;
        box-shadow: none;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        ${props => (props.withoutBg ? withoutBgStyles : defaultControlCSS)}

        svg path {
            fill: ${props => props.theme.selector.icon.fill};
        }
    }

    .selector__indicators .selector__indicator-separator {
        display: none;
    }

    .selector__indicators {
        display: flex;

        span {
            display: flex;
        }
    }

    .selector__menu {
        margin: 0;
        min-width: 128px;
        border-radius: 12px;
        box-sizing: border-box;
        overflow: hidden;
        color: ${props => props.theme.selector.menu.color};
        background: ${props => props.theme.selector.menu.background};
        display: flex;
        flex-direction: column;
        max-height: ${props => props.menuHeight}px;

        &-list {
            padding: 0;
        }
    }

    .selector__option {
        padding: 10px 16px;
        cursor: pointer;
        display: flex;
        align-items: center;
    }

    .selector__option:hover,
    .selector__option--is-focused {
        background: ${props => props.theme.root.colors.basicColors['6%']};
    }

    .selector__option--is-selected {
        background: ${props => props.theme.selector.menu.itemHover};
    }
    .selector__value-container {
        padding: 0;
        margin: 0;
        flex: auto;
        min-width: 65px;
    }

    .selector__single-value {
        display: flex;
        align-items: center;
        overflow: hidden;

        & + div {
            position: absolute;
            top: -100px;
        }
    }

    .selector__single-value,
    .selector__input {
        margin: 0;
        color: ${props => props.theme.selector.base.color};
    }

    .selector__dropdown-indicator {
        padding: 0;
    }

    &.selector--is-disabled {
        .selector__control {
            background: ${props => props.theme.selector.disabled.background};
        }
        .selector__single-value {
            color: ${props => props.theme.selector.disabled.color};
        }
    }

    //fix DummyInput in react-select with isSearchable=false
    input[aria-readonly='true'] {
        position: absolute;
    }
`;

export const EmojiPrefix = styled.span`
    font-size: ${props => (props.theme.emoji.isCBDTEmoji ? 18 : 24)}px;
    margin-right: 4px;
    margin-top: ${props => (props.theme.emoji.isNativeEmoji ? 2 : 0)}px;
`;
